module.exports = __webpack_public_path__ + "img/07.5a85639c.jpg";